module.exports = __webpack_public_path__ + "media/images/m-soudanin-93d9f7ee.png";